import React, { useEffect, useState } from 'react';
import './AccountClassForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function AccountClassForm({ initial, accountCategories, onSave, onCancel, loading }) {
  const [account_category_id, setAccountCategoryId] = useState(initial?.account_category_id || '');
  const [class_code, setClassCode] = useState(initial?.class_code || '');
  const [class_name, setClassName] = useState(initial?.class_name || '');
  const [sort_order, setSortOrder] = useState(initial?.sort_order || 100);
  const [system_locked, setSystemLocked] = useState(initial?.system_locked ?? false);
  const [description, setDescription] = useState(initial?.description || '');
  const [error, setError] = useState('');

  useEffect(() => {
    setAccountCategoryId(initial?.account_category_id || '');
    setClassCode(initial?.class_code || '');
    setClassName(initial?.class_name || '');
    setSortOrder(initial?.sort_order || 100);
    setSystemLocked(initial?.system_locked ?? false);
    setDescription(initial?.description || '');
  }, [initial]);

  const validate = () => {
    if (!account_category_id) return 'Account category is required.';
    if (!class_code.trim()) return 'Class code is required.';
    if (!/^[a-z0-9_]{2,20}$/.test(class_code.trim())) return 'Class code must be 2-20 lowercase letters, numbers or underscores.';
    if (!class_name.trim()) return 'Class name is required.';
    if (!String(sort_order).match(/^\d+$/) || Number(sort_order) < 1) return 'Sort order must be a positive number.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      account_category_id: Number(account_category_id),
      class_code: class_code.trim().toLowerCase(),
      class_name: class_name.trim(),
      sort_order: Number(sort_order),
      system_locked,
      description: description.trim(),
    });
  };

  return (
    <form className="account-class-form" onSubmit={handleSubmit} style={{ minWidth: 360 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div style={{ minWidth: 220 }}>
          <label>Account Category<RequiredMark /></label><br />
          <select className="styled-input" value={account_category_id} onChange={(e) => setAccountCategoryId(e.target.value)}>
            <option value="">Select Account Category</option>
            {accountCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>{cat.category_name}</option>
            ))}
          </select>
        </div>
        <div>
          <label>Class Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={class_code}
            onChange={(e) => setClassCode(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 20))}
            maxLength={20}
            placeholder="e.g., fixed_asset"
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 14, marginTop: 10, flexWrap: 'wrap' }}>
        <div style={{ minWidth: 260 }}>
          <label>Class Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={class_name}
            onChange={(e) => setClassName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Fixed Asset"
          />
        </div>
        <div>
          <label>Sort Order<RequiredMark /></label><br />
          <input
            className="styled-input"
            type="number"
            min="1"
            value={sort_order}
            onChange={(e) => setSortOrder(e.target.value)}
            style={{ width: 90 }}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={system_locked} onChange={(e) => setSystemLocked(e.target.checked)} />
          System Locked
        </label>
      </div>

      <div style={{ marginTop: 10 }}>
        <label>Description</label><br />
        <textarea
          className="styled-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          style={{ width: '100%', resize: 'vertical' }}
          placeholder="Optional notes"
        />
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default AccountClassForm;
